import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DestroyService } from '../../../services/destroy/destroy.service';
import { ModalService } from '../../../services/modal/modal.service';
import {
  PaymentStatus,
  PaymentType,
  SubscriptionModel,
  SubscriptionPaymentCreateModel,
  SubscriptionServiceProxy,
} from '../../../../shared/service-proxies/event-service-proxy';
import { takeUntil } from 'rxjs';
import { DateFormatterPipe } from '../../../pipes/date/date-formatter.pipe';
import { differenceInDays, parseISO } from 'date-fns';
import { DateLocaleService } from '../../../services/date-locale/date-locale.service';
import { ToastrService } from '../../../services/toastr/toastr.service';
import { ErrorService } from '../../../services/error/error.service';

@Component({
  selector: 'app-modal-prolong',
  templateUrl: './modal-prolong.component.html',
  styleUrl: './modal-prolong.component.scss',
  providers: [DestroyService],
  standalone: false,
})
export class ModalProlongComponent {
  @Input() subscription: SubscriptionModel = new SubscriptionModel();

  @Output() change = new EventEmitter<void>();

  isLoadingSend: boolean = false;
  todayDate = this.dateFormatterPipe.transform(new Date(), 'yyyy-MM-dd');
  daysDifference: number = 0;
  formProlongSubscription = {
    expiresAt: null,
    price: 0,
    currency: '',
  };

  constructor(
    private errorService: ErrorService,
    private toastrService: ToastrService,
    private dateFormatterPipe: DateFormatterPipe,
    private destroyService: DestroyService,
    private modalService: ModalService,
    private _subscriptionService: SubscriptionServiceProxy,
    public dateLocaleService: DateLocaleService
  ) { }

  ngOnChanges(): void {
    if (this.subscription) this.initialize();
  }

  initialize() {
    this.formProlongSubscription.expiresAt = null;
    this.daysDifference = 0;
    this.formProlongSubscription.price = this.subscription?.orderProduct?.price;
    this.formProlongSubscription.currency = 'usd';
  }

  prolongSubscription() {
    const body = new SubscriptionPaymentCreateModel();
    const id = this.subscription?.id;
    const expiresAtDate = new Date(this.formProlongSubscription.expiresAt);
    if (isNaN(expiresAtDate.getTime())) {
      this.errorService.handleError('', 'Пожалуйста, выберите дату окончания.');
      return;
    }
    
    if (expiresAtDate < new Date(this.subscription.expiresAt)) {
      this.errorService.handleError('', 'Выберите дату больше за дату окончания.');
      return
    }
    this.isLoadingSend = true;
    body.transactionId = '';
    body.expiresAt = expiresAtDate;
    body.properties = [];
    body.amount = this.formProlongSubscription.price;
    body.currency = this.formProlongSubscription.currency;
    body.status = PaymentStatus.Completed;
    body.type = PaymentType.RecurringPayment;

    this._subscriptionService
      .prolongSubscription(id, body)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe(
        (res) => {
          this.closeModal();
          this.toastrService.showSuccessToastr('Подписка успешно продолжена!');
          this.isLoadingSend = false;
          this.change.emit();
        },
        (error) => {
          this.errorService.handleError(
            error,
            'Не удалось продлить подписку. Попробуйте позже.'
          );
          this.isLoadingSend = false;
        }
      );
  }

  closeModal() {
    this.initialize();
    this.modalService.closeModal();
  }

  calculateDays(event: any) {
    const raw = event?.startDate?.$d || event?.startDate || null;
    if (!raw) {
      return;
    }

    const date = new Date(raw);
    if (!isNaN(date.getTime())) {
      this.formProlongSubscription.expiresAt = date;
    } else {
      return;
    }

    const formatted = this.dateFormatterPipe.transform(
      date,
      'yyyy-MM-dd HH:mm:ss'
    );
    if (!formatted) return;

    const targetDate = parseISO(formatted.replace(' ', 'T'));
    const expiresAt = new Date(this.subscription.expiresAt);
    this.daysDifference = differenceInDays(targetDate, expiresAt);
  }
}
